import { Link } from '@playbooks/ui/components/link';

const IndexSplashFooter = () => (
	<div className='border-t border-border px-4 py-4'>
		<div className='mx-auto px-3 max-w-xxl flex-column sm:flex-between gap-3'>
			<span className='text-foreground-body text-xs'>© {new Date().getFullYear()} Playbooks, Inc.</span>
			<div className='flex-start gap-4'>
				<Link
					variant='link'
					size='xs'
					href='https://twitter.com/playbooks_ai'
					target='_blank'
					className='text-foreground-body hover:text-white'>
					Twitter
				</Link>
				<Link
					variant='link'
					size='xs'
					href='https://slack.playbooks.ai'
					target='_blank'
					className='text-foreground-body hover:text-white'>
					Slack
				</Link>
				<Link
					variant='link'
					size='xs'
					href='https://www.youtube.com/@playbookshq'
					target='_blank'
					className='text-foreground-body hover:text-white'>
					YouTube
				</Link>
				<Link
					variant='link'
					size='xs'
					href='https://github.com/playbooks-hq'
					target='_blank'
					className='text-foreground-body hover:text-white'>
					GitHub
				</Link>
			</div>
		</div>
	</div>
);
export { IndexSplashFooter };
